import React from "react";
import { Asterisk } from "lucide-react";
import { usePrice } from "@/lib/price";

const baseItems = [
  "100+ GROUNDED PLAYBOOKS",
  "AI INTERVIEW ROLE-PLAY",
  "ATS-PROOF RESUMES",
  "NO REPOSTS · NO SCRAPERS",
  "CONTENT MACHINE",
  "178 TOOL DIRECTORY",
];

export default function Ticker() {
  const { price } = usePrice();
  const items = ["LIVE ATS JOBS", ...baseItems, `${price} ALL ACCESS`];
  const loop = [...items, ...items];
  return (
    <section
      data-testid="ticker"
      className="border-y-4 border-[#0a0a0a] bg-[#FFE600] py-4 overflow-hidden"
    >
      <div className="marquee-track">
        {loop.map((t, i) => (
          <span
            key={i}
            className="font-display text-2xl md:text-4xl px-6 flex items-center gap-6"
          >
            {t}
            <Asterisk size={28} strokeWidth={2.8} />
          </span>
        ))}
      </div>
    </section>
  );
}
